module.exports = __webpack_public_path__ + "media/metronic/_theme/media/error/bg3-ff13001e6e0fa9e501e430f06850d156.jpg";